import { PHONE_COUNTRY_CODES, PHONE_COUNTRY_CODES_MASKS } from '@common/constants';
import { getCleanPhone } from '@common/utils/getCleanPhone';

const PHONE_CODE_MAX_LENGTH = 4;

type TypeMask = Array<string | RegExp>;

const getNumberMaskByCountryCode = (code: string): TypeMask => {
	return PHONE_COUNTRY_CODES_MASKS[code] || PHONE_COUNTRY_CODES_MASKS.default;
};

const getCountryCodeByRawPhone = (rawPhone: string): string | undefined => {
	const phone = getCleanPhone(rawPhone);
	const greedy = phone.length > PHONE_CODE_MAX_LENGTH ? '?' : '';

	return new RegExp(
		`"(${phone.slice(0, PHONE_CODE_MAX_LENGTH)}${greedy})`,
	)
		.exec(PHONE_COUNTRY_CODES)
		?.pop();
};

const createCountryCodeMask = (countryCode: string): TypeMask => {
	return ['+', ...(countryCode.split('') as TypeMask).fill(/\d/)];
};

const getCountryCodeMask = (countryCode: string | undefined): TypeMask => {
	const defaultMask: TypeMask = ['+', /\d/];

	if (countryCode) {
		return createCountryCodeMask(countryCode);
	}

	return defaultMask;
};

const createPhoneMask = (countryCodeMask: TypeMask, countryPhoneMask: TypeMask): TypeMask => {
	return [...countryCodeMask, ' ', ...countryPhoneMask];
};

export const getPhoneMask = (inputValue: string): TypeMask => {
	const countryCode = getCountryCodeByRawPhone(inputValue);
	const countryCodeMask = getCountryCodeMask(countryCode);
	const numberMask = getNumberMaskByCountryCode(countryCode);

	return createPhoneMask(
		countryCodeMask,
		numberMask,
	);
};
